
import BillOfLading from "@/store/modules/shipment/declarecustoms/billoflading";
import { Component, ActionButtonConfig, FormModalMixins, menuRouteHelper, systemConst,Prop,appConst} from "@/lib";


@Component
export default class BillOfLadingDownloadModal extends FormModalMixins  {
  model = new BillOfLading();

  get loading() {
    return this.$store.state.shipment.declarecustoms.getBillOfLadingLoading;
  }

  /** 下载中英文翻译 */
  get downloadText() {
    return this.L("app.Action.Download");
  }

  created() {
      Object.assign(this.config, {modelTitleL: "app.DeclareCustoms.BillOfLadingDownload", labelWidth:100, width:600, isHideOk: true });
  }

  download(fileInfo) {
    let url = appConst.remoteServiceBaseUrl + "/" + appConst.uploadUrl.previewAction + "?id=" + fileInfo.fileId;
    window.open(url);
  }
  close() {
      this.config.isShow = false;
      this.model = new BillOfLading();
  }

  async visibleChange(value) {
      if (value) {
        this.model.fileList = await this.$store.dispatch({type: "shipment/declarecustoms/getBillOfLading"});
      }
  }
}
